<div fxFlex="" class="header-div">
  <!-- start : topnavbar-->
  <mat-toolbar
    #header
    class="mat-elevation-z6 main-toolbar {{
      menu ? 'toolbar-home' : 'toolbar-non-home'
    }}"
  >
    <mat-toolbar-row>
      <div class="center navbar-button first menu">
        <button
          mat-icon-button
          (click)="subNavClose(); toggleSideNav()"
          aria-label="Menu"
        >
          <mat-icon>menu</mat-icon>
        </button>
      </div>
      <!-- icone valdoise-->
      <div class="center navbar-button home {{ isMobile ? 'home-sp' : '' }}">
        <a
          (click)="subNavClose(); sendGaEvent('Home', 'Home')"
          routerLink=""
          aria-label="Vers accueil"
        >
          <img
            [src]="
              header.color == 'warn' || !menu
                ? 'assets/logos/logo_header_dark.png'
                : 'assets/logos/logo_header.png'
            "
            [alt]="'logo département Val d‘Oise'"
          />
        </a>
      </div>
      <!-- search input-->
      <div class="menu-search" fxShow="true" fxHide.lt-sm="true">
        <search-field
          (keyWords)="updateKeyWords($event)"
          (kwHidden)="hideKw($event)"
          (inputWord)="setInput($event)"
          [keywordInput]="kwInput"
          (click)="header.color = 'warn'"
        ></search-field>
      </div>

      <!-- CENTER POSITION-->
      <div *ngIf="!isMobile" fxFlex="" class="center">
        <div *ngIf="currentScreenWidth > 600">
          <span
            *ngIf="!menu && !(title[0] == '')"
            class="default-cursor title-first"
            [innerText]="
              title[0] ? (title[0] | translate) : ('All' | translate)
            "
          ></span>
          <span
            *ngIf="
              title.length > 1 &&
              !(title[0] == '') &&
              title[1] != 'Allundefined'
            "
            class="default-cursor title-second"
            [innerText]="'. ' + (title[1] | translate)"
          ></span>
        </div>
      </div>

      <!-- RIGHT POSITION-->
      <div
        [class]="
          isMap
            ? ['center', 'navbar-button', 'map-icon-highlight']
            : ['center', 'navbar-button']
        "
      >
        <a
          (click)="
            closeSideNav(); subNavClose(); sendGaEvent('-', 'Territoire')
          "
          routerLink="/carte"
          mat-icon-button
          disableRipple="true"
          aria-label="Vers carte"
        >
          <mat-icon svgIcon="all-poi"></mat-icon>
        </a>
      </div>
      <div class="navbar-button center {{ is360 ? 'map-icon-highlight' : '' }}">
        <a
          (click)="subNavClose(); sendGaEvent('360', 'Accès 360')"
          routerLink="panorama"
          mat-icon-button
          disableRipple="true"
          aria-label="Vers panorama"
        >
          <mat-icon class="custom-icon" svgIcon="panorama"></mat-icon>
        </a>
      </div>
      <div
        [class]="
          isInspiration
            ? ['center', 'last', 'navbar-button', 'map-icon-highlight']
            : ['center', 'last', 'navbar-button']
        "
      >
        <a
          (click)="subNavClose(); sendGaEvent('-', 'Suggestion')"
          routerLink="suggestions"
          mat-icon-button
          disableRipple="true"
          aria-label="Vers inspiration"
        >
          <mat-icon class="custom-icon" svgIcon="inspiration"></mat-icon>
        </a>
      </div>
    </mat-toolbar-row>

    <!-- kw -->
    <mat-toolbar-row #kwDiv *ngIf="!kwHidden" class="kw-div">
      <div class="kw-div-content">
        <h6>{{ 'KeywordsTooltip' | translate }}</h6>
        <ul list-style="none">
          <li *ngFor="let keyw of kw">
            <a
              routerLink="/carte"
              (click)="
                kwHidden = true;
                sendGaEvent(
                  'Recherche : '.concat(inputWord),
                  'Recherche',
                  'Sélection : '.concat(keyw)
                );
                kwInput = keyw
              "
            >
              {{ keyw }}</a
            >
          </li>
        </ul>
      </div>
      <div class="kw-div-content">
        <h6>Catégories:</h6>
        <ul>
          <li *ngFor="let cat of categoriesToShow">
            <a
              routerLink="{{ cat['routerLink'] }}"
              [queryParams]="cat['queryParams']"
              (click)="
                kwHidden = true;
                sendGaEvent(
                  'Recherche : '.concat(inputWord),
                  'Recherche',
                  'Sélection : '.concat(cat['name'])
                )
              "
            >
              {{ cat['name'] }}</a
            >
          </li>
        </ul>
      </div>
    </mat-toolbar-row>
  </mat-toolbar>

  <!-- end : topnavbar-->
  <div *ngIf="menu" class="menu-search-sp" fxHide="true" fxShow.lt-sm="true">
    <search-field></search-field>
  </div>
  <!--  start: menu  -->
  <div class="drawer" [hidden]="sideNavState">
    <div class="side-row">
      <nav
        fxFlex=""
        class="left-sidenav sidenav {{ !hidden ? 'left-sidenav-shadow' : '' }}"
        [hidden]="collapsed"
      >
        <div class="menu-header">
          <img
            routerLink=""
            (click)="toggleSideNav()"
            class="menu-icon link-cursor"
            src="assets/logos/apple-touch-icon.png"
            alt="Val d‘Oise icon"
          />
          <div fxFlex="" class="menu-title default-cursor"></div>

          <button mat-icon-button class="close-menu" (click)="toggleSideNav()">
            <mat-icon>close</mat-icon>
          </button>
        </div>
        <div>
          <div class="center">
            <search-field *ngIf="isMobile"></search-field>
          </div>
        </div>
        <div></div>
        <mat-nav-list class="nav-list nav-list-r">
          <div>
            <br fxShow="true" fxHide.lt-sm="true" />
            <h3 matSubheader class="default-cursor" translate="">
              <mat-icon class="sub-icon material-icons-outlined" color="primary"
                >explore</mat-icon
              >
              Explore
            </h3>
          </div>

          <div class="sub-menu">
            <div class="nav-link">
              <!-- ? GA : Carte ? -->
              <a
                (click)="
                  toggleSideNav(); subNavClose(); sendGaEvent('-', 'Territoire')
                "
                routerLink="/carte"
                mat-list-item
                >{{ 'AllPOI' | translate }}</a
              >
              <!-- ? GA : Carte ? -->
            </div>
            <!--  web nav  -->
            <div fxShow="true" fxHide.lt-sm="true">
              <!-- ? GA : patrimoine ? -->
              <a
                (click)="
                  subNavToggle(0);
                  sendGaEvent('-', 'Patrimoine');
                  sendGaEvent('TOUS - patrimoine', 'Sous-catégorie')
                "
                mat-list-item
                >{{ 'Heritages' | translate }}
                <span fxFlex=""></span>
                <mat-icon class="chevron">arrow_forward_ios</mat-icon>
              </a>
              <!-- ? GA : patrimoine ? -->
            </div>

            <!--  mobile nav  -->
            <div fxHide="true" fxShow.lt-sm="true" class="cat-item-sp">
              <!-- ? GA : circuit ? -->
              <a
                mat-list-item
                (click)="
                  swapToSubNav();
                  subNavToggle(0);
                  sendGaEvent('-', 'Patrimoine');
                  sendGaEvent('TOUS - patrimoine', 'Sous-catégorie')
                "
                >{{ 'Heritages' | translate }}
                <span fxFlex=""></span>
                <mat-icon class="chevron">arrow_forward_ios</mat-icon>
              </a>
              <!-- ? GA : circuit ? -->
            </div>

            <!--  web nav  -->
            <div fxShow="true" fxHide.lt-sm="true">
              <!-- ? GA : circuit ? -->
              <a
                (click)="
                  subNavToggle(1);
                  sendGaEvent('-', 'Circuits');
                  sendGaEvent('TOUS - circuits', 'Sous-catégorie')
                "
                mat-list-item
                >{{ 'Circuits' | translate }}
                <span fxFlex=""></span>
                <mat-icon class="chevron">arrow_forward_ios</mat-icon>
              </a>
              <!-- ? GA : circuit ? -->
            </div>

            <!--  mobile nav  -->
            <div fxHide="true" fxShow.lt-sm="true" class="cat-item-sp">
              <!-- ? GA : circuit ? -->
              <a
                mat-list-item
                (click)="
                  swapToSubNav();
                  subNavToggle(1);
                  sendGaEvent('-', 'Circuits');
                  sendGaEvent('TOUS - circuits', 'Sous-catégorie')
                "
                >{{ 'Circuits' | translate }}
                <span fxFlex=""></span>
                <mat-icon class="chevron">arrow_forward_ios</mat-icon>
              </a>
              <!-- ? GA : circuit ? -->
            </div>
          </div>

          <mat-divider></mat-divider>

          <div>
            <br fxShow="true" fxHide.lt-sm="true" />
            <h3 matSubheader class="default-cursor" translate="">
              <mat-icon class="sub-icon" aria-hidden="true" color="primary"
                >sentiment_very_satisfied</mat-icon
              >
              ToDo
            </h3>
          </div>

          <div class="sub-menu">
            <div class="nav-link">
              <!-- ? GA :  Activités et Loisirs ? -->
              <a
                (click)="
                  toggleSideNav();
                  subNavClose();
                  sendGaEvent('-', 'Services');
                  sendSubcategGaEvent('Activités et Loisirs')
                "
                routerLink="/carte/{{ categoriesConfig.services.id }}/{{
                  subCategoriesConfig.activities.id
                }}"
                mat-list-item
                >{{ subCategoriesConfig.activities.name | translate }}</a
              >
              <!-- ? GA :  Activités et Loisirs ? -->
            </div>
            <div class="nav-link">
              <!-- ? GA :  jeux ? -->
              <a
                (click)="
                  toggleSideNav(); subNavClose(); sendGaEvent('-', 'Jeux')
                "
                routerLink="/carte/{{ categoriesConfig.games.id }}"
                mat-list-item
                >{{ categoriesConfig.games.name | translate }}</a
              >
              <!-- ? GA :  jeux ? -->
            </div>
            <div class="nav-link">
              <!-- ! GA :  Sorties nature (maincateg: agenda) ! -->
              <a
                (click)="
                  toggleSideNav();
                  subNavClose();
                  sendGaEvent('-', 'Agenda');
                  sendSubcategGaEvent('Sorties Nature')
                "
                routerLink="/carte/{{ categoriesConfig.event.id }}/2"
                mat-list-item
                >{{ 'Outing' | translate }}</a
              >
              <!-- ! GA :  Sorties nature (maincateg: agenda) ! -->
            </div>
          </div>

          <mat-divider></mat-divider>

          <div>
            <br fxShow="true" fxHide.lt-sm="true" />
            <h3 matSubheader class="default-cursor" translate="">
              <mat-icon
                class="sub-icon"
                aria-hidden="true"
                color="primary"
                svgIcon="icon_Services"
              ></mat-icon>
              Services
            </h3>
          </div>

          <div class="sub-menu">
            <div class="nav-link">
              <!-- ? GA :  service ? -->
              <a
                (click)="
                  toggleSideNav();
                  subNavClose();
                  sendGaEvent('-', 'Services');
                  sendGaEvent('TOUS - services', 'Sous-catégorie')
                "
                routerLink="/carte/{{ categoriesConfig.services.id }}"
                mat-list-item
                >{{ 'AllServices' | translate }}</a
              >
              <!-- ? GA :  service ? -->
            </div>
            <div class="nav-link">
              <!-- ? GA :  Hébergement ? -->
              <a
                (click)="
                  toggleSideNav();
                  subNavClose();
                  sendGaEvent('-', 'Services');
                  sendSubcategGaEvent('hébergement')
                "
                routerLink="/carte/{{ categoriesConfig.services.id }}/{{
                  subCategoriesConfig.lodging.id
                }}"
                mat-list-item
                >{{ subCategoriesConfig.lodging.name | translate }}</a
              >
              <!-- ? GA :  Hébergement ? -->
            </div>
            <div class="nav-link">
              <!-- ? GA :  Restaurants ? -->
              <a
                (click)="
                  toggleSideNav();
                  subNavClose();
                  sendGaEvent('-', 'Services');
                  sendSubcategGaEvent('Restaurants')
                "
                routerLink="/carte/{{ categoriesConfig.services.id }}/{{
                  subCategoriesConfig.restaurants.id
                }}"
                mat-list-item
                >{{ subCategoriesConfig.restaurants.name | translate }}</a
              >
              <!-- ? GA :  Restaurants ? -->
            </div>
            <div class="nav-link">
              <!-- ? GA :  Commerces et services ? -->
              <a
                (click)="
                  toggleSideNav();
                  subNavClose();
                  sendGaEvent('-', 'Services');
                  sendSubcategGaEvent('Commerces et services')
                "
                routerLink="/carte/{{ categoriesConfig.services.id }}/{{
                  subCategoriesConfig.shopping.id
                }}"
                mat-list-item
                >{{ subCategoriesConfig.shopping.name | translate }}</a
              >
              <!-- ? GA :  Commerces et services ? -->
            </div>
            <div class="nav-link">
              <!-- ? GA : Informations touristiques ? -->
              <a
                (click)="
                  toggleSideNav();
                  subNavClose();
                  sendGaEvent('-', 'Services');
                  sendSubcategGaEvent('Informations touristiques')
                "
                routerLink="/carte/{{ categoriesConfig.services.id }}/{{
                  subCategoriesConfig.touristInfo.id
                }}"
                mat-list-item
                >{{ subCategoriesConfig.touristInfo.name | translate }}</a
              >
              <!-- ? GA : Informations touristiques ? -->
            </div>
            <div class="nav-link">
              <!-- ? GA : Informations touristiques ? -->
              <a
                (click)="
                  toggleSideNav();
                  subNavClose();
                  sendGaEvent('-', 'Services');
                  sendSubcategGaEvent('Producteurs Locaux')
                "
                routerLink="/carte/{{ categoriesConfig.services.id }}/{{
                  subCategoriesConfig.productLocaux.id
                }}"
                mat-list-item
                >{{ subCategoriesConfig.productLocaux.name | translate }}</a
              >
              <!-- ? GA : Informations touristiques ? -->
            </div>
          </div>

          <mat-divider></mat-divider>

          <div>
            <br fxShow="true" fxHide.lt-sm="true" />
            <h3 matSubheader class="default-cursor">
              <mat-icon class="sub-icon" aria-hidden="true" color="primary"
                >event_note</mat-icon
              >
              {{ categoriesConfig.event.name | translate }}
            </h3>
          </div>

          <div class="sub-menu">
            <div class="nav-link">
              <!-- ? GA : agenda ? -->
              <a
                (click)="
                  toggleSideNav(); subNavClose(); sendGaEvent('-', 'Agenda')
                "
                routerLink="/carte/{{ categoriesConfig.event.id }}"
                mat-list-item
                >{{ 'AllEvents' | translate }}</a
              >
              <!-- ? GA : agenda ? -->
            </div>
            <div class="nav-link">
              <!-- ? GA : agenda ? -->
              <a
                (click)="
                  toggleSideNav(); subNavClose(); sendGaEvent('-', 'Agenda')
                "
                routerLink="/carte/{{ categoriesConfig.event.id }}/0"
                mat-list-item
                >{{ 'Ongoing' | translate }}</a
              >
              <!-- ? GA : agenda ? -->
            </div>
            <div class="nav-link">
              <!-- ? GA : agenda ? -->
              <a
                (click)="
                  toggleSideNav(); subNavClose(); sendGaEvent('-', 'Agenda')
                "
                routerLink="/carte/{{ categoriesConfig.event.id }}/1"
                mat-list-item
                >{{ 'Forthcoming' | translate }}</a
              >
              <!-- ? GA : agenda ? -->
            </div>
          </div>

          <div class="partner-block" *ngIf="isMobile">
            <img
              class="logo-foot-sp"
              src="assets/logos/logo_Val_Oise.png"
              alt="Val d‘Oise"
            />
            <img
              class="logo-foot-sp"
              src="assets/logos/logo_IleFrance.png"
              alt="Ile de France"
            />
            <img
              class="logo-foot-sp"
              src="assets/logos/logo_gvnmt.jpg"
              alt="gouvernement"
            />
          </div>
        </mat-nav-list>
      </nav>

      <nav fxFlex="" *ngIf="!hidden" class="right-sidenav sidenav">
        <div *ngIf="isMobile" class="menu-header">
          <img
            routerLink=""
            (click)="toggleSideNav()"
            class="menu-icon link-cursor"
            src="assets/logos/apple-touch-icon.png"
            alt="Val d‘Oise icon"
          />
          <div fxFlex="" class="menu-title default-cursor">
            <h2>menu</h2>
          </div>

          <button mat-icon-button class="close-menu" (click)="toggleSideNav()">
            <mat-icon>close</mat-icon>
          </button>
        </div>

        <div *ngIf="isMobile" class="back-div">
          <button
            mat-flat-button
            class="expand-sp"
            (click)="swapToSubNav(); subNavClose()"
            color="accent"
          >
            <mat-icon>arrow_back_ios_new</mat-icon>
            {{ 'GoBack' | translate }}
          </button>
        </div>

        <mat-nav-list class="nav-list" style="overflow: auto">
          <div>
            <br fxShow="true" fxHide.lt-sm="true" />
            <h3
              matSubheader
              class="link-cursor"
              routerLink="/carte/{{ heritageHidden ? '1' : '0' }}"
              (click)="toggleSideNav(); subNavClose(); swapToSubNav()"
            >
              <mat-icon
                class="sub-icon"
                svgIcon="icon_{{ heritageHidden ? '1' : '0' }}"
              ></mat-icon>
              {{
                (heritageHidden ? 'AllCircuits' : 'AllHeritages') | translate
              }}
            </h3>
          </div>
          <mat-divider fxHide="true" fxShow.lt-sm="true"></mat-divider>
          <!--  sub cat  -->
          <div [hidden]="heritageHidden" *ngFor="let cat of heritageSubCat">
            <div class="sub-cat-line">
              <mat-icon svgIcon="icon__{{ cat.id }}"></mat-icon>
              <!-- ? GA : cat.name ? -->
              <a
                (click)="
                  toggleSideNav();
                  subNavClose();
                  swapToSubNav();
                  sendSubcategGaEvent(cat.name)
                "
                routerLink="/carte/{{ cat.parentCategId }}/{{ cat.id }}"
                mat-list-item
              >
                {{ displaySubCategName(cat, 0) }}
              </a>
              <!-- ? GA : cat.name ? -->
            </div>
            <mat-divider></mat-divider>
          </div>
          <div [hidden]="heritageHidden">
            <div class="sub-cat-line">
              <mat-icon svgIcon="icon__null"></mat-icon>
              <a
                (click)="
                  toggleSideNav();
                  subNavClose();
                  swapToSubNav();
                  sendSubcategGaEvent('Insolite')
                "
                routerLink="/carte/{{ 0 }}/{{ -1 }}"
                mat-list-item
                >{{ 'Insolite' | translate }}</a
              >
            </div>
          </div>
          <!--          -->
          <div [hidden]="circuitHidden" class="sub-menu">
            <div *ngFor="let cat of circuit; let last = last">
              <div class="sub-cat-line">
                <mat-icon svgIcon="icon_circuit_{{ cat.id }}"></mat-icon>
                <!-- ? GA : cat.name ? -->
                <a
                  (click)="
                    toggleSideNav();
                    subNavClose();
                    swapToSubNav();
                    sendSubcategGaEvent(cat.name)
                  "
                  routerLink="/carte/1/{{ cat.id }}"
                  mat-list-item
                  >{{ displaySubCategName(cat, 1) | translate }}</a
                >
                <!-- ? GA : cat.name ? -->
              </div>
              <mat-divider *ngIf="!last"></mat-divider>
            </div>
          </div>
        </mat-nav-list>
      </nav>
    </div>

    <div fxHide="true" fxShow.lt-sm="true" class="footer-sp">
      <!-- ? GA : CGU ? -->
      <a
        fxFlex=""
        (click)="closeSideNav(); subNavClose(); sendGaEvent('cgu ml', 'Info')"
        class="footer-sp-link"
        routerLink="about/cgu"
        >CGU & Mentions légales</a
      >
      <!-- ? GA : CGU ? -->
      <!-- ? GA : Info ? -->
      <a
        fxFlex=""
        (click)="closeSideNav(); subNavClose(); sendGaEvent('Info', 'Info')"
        class="footer-sp-link"
        routerLink="about/info"
        >Infos</a
      >
      <!-- ? GA : Info ? -->
      <!-- ? GA : Partenaire ? -->
      <a
        fxFlex=""
        (click)="closeSideNav(); subNavClose()"
        class="footer-sp-link"
        routerLink="about/partenaires"
        >Partenaires</a
      >
      <!-- ? GA : Partenaire ? -->
    </div>
  </div>
  <!--  end: menu  -->
  <div
    [hidden]="sideNavState"
    class="backdrop-header"
    (click)="closeSideNav()"
  ></div>

  <div
    class="content"
    (click)="
      closeSideNav();
      kwHidden = true;
      viewport.getScrollPosition()[1] == 0 ? (header.color = null) : null
    "
  >
    <router-outlet></router-outlet>
  </div>
  <app-footer></app-footer>
</div>
